import { createSelector } from "reselect";
import { getKaMetlhaFuneralClaim } from "./index";
import { FORM_STATUS } from "../../reducers/status";
import { getClaimentType } from "./claimentDetails";

export const getUploadDocuments= createSelector(
    getKaMetlhaFuneralClaim,
  (kaMetlhaFuneralClaim) => kaMetlhaFuneralClaim.uploadDocuments
);
export const getUploadDocumentsForm = createSelector(
    getUploadDocuments,
    (uploadDocuments) => uploadDocuments.form
  );


export const getUploadDocumentValidations=createSelector(getUploadDocumentsForm,(uploadDocumentsFormFields)=>{
const {beneficiaryId,...commonDocuments} = uploadDocumentsFormFields
  const policyHolderDocuments={...commonDocuments}
  const beneficiaryDocuments ={beneficiaryId,...commonDocuments}
  const nomineeDocuments ={...commonDocuments}
return{
  'Beneficiary': beneficiaryDocuments,
  'Policy holder': policyHolderDocuments,
  'Nominee': nomineeDocuments,
};
})



 export  const getUploadDocumentsValid=createSelector(getUploadDocuments,(uploadDocumentsForm)=>uploadDocumentsForm.formStatus === FORM_STATUS.VALID)

 const inputFieldLabels = {
  deathCertificate: 'Certified Copy Of Death Certificate',
  proofOfBanking: 'Proof Of Banking',
  beneficiaryId: 'Certified Copy Of Beneficiary ID',
  proofOfAddress: 'Proof Of Address',
  // confirmationOfBankAccount:'Confirmation Of Bank Account',
  affidavitRelation:'Affidavit Confirming Relation',
  claimantsId: 'Claimant Id Proof',
  affidavitSurname: 'Affidavit Confirming Surname is Difference',
  marriageCertificate: 'Certified copy of marriage certificate; Commissioner of oath',
  marriageAffidavit: 'Declaration/affidavit from a third party confirming the duration of relationship e.g., Tribal Chief, Minister of Religion, Parents of the deceased',
  childBirthCertificate: 'Certified copy of child’s birth certificate',
  policeReport: 'Police report'
};

 export const getUploadDocumentsSummary = createSelector(
  getUploadDocumentValidations,
  getClaimentType,
  getUploadDocumentsForm,
  (uploadDocumentValidation,claimentType, uploadDocumentForm) => {
      return Object.keys(uploadDocumentValidation[claimentType.displayValue])
          ?.flatMap((item) => ({
              label: inputFieldLabels[item],
              value: uploadDocumentForm[item]?.fileName ?? '-',
          }))
          .filter(({ label }) => label);
  }
);

export const getUploadDocumentArray=createSelector(getUploadDocumentValidations,getClaimentType,(uploadDocumentValidated,claimentType)=>{
  return Object.values(uploadDocumentValidated[claimentType?.displayValue])
  })